import config from '../conf';
import { getAuthLogin } from './helpers';

export const API_MESSAGING = [
  {
    response: 'Duplicate email address found.',
    friendlyMessage: 'Duplicate email address found.',
  },
  {
    response: 'An account with this email already exists.',
    friendlyMessage: 'An account with this email already exists.',
  },
  {
    response: 'The account already exists.',
    friendlyMessage: 'An account with this company profile already exists.',
  },
];

export const API_SECONDARY_MESSAGING = [
  {
    response: 'The account already exists.',
    friendlyMessage: ['Please try again with different company information or contact us at', '877-224-3650.'],
  },
];

export const RATE_PLAN_IDS = {
  avataxAnnualPlatform: {
    'Level 0': '2c92a0fe5b42d2b1015b6395087a0c59',
    'Level 1': '2c92a0fe51e898bb0152039cbfa72632',
    'Level 2': '2c92a0ff51e898b50152039cd7552488',
    'Level 3': '2c92a0fd51e8883c0152039cf4724a60',
    'Level 4': '2c92a0ff51e898b50152039d10ae2548',
  },
  avataxServiceProAnnual: '2c92a0fe51e898bb0152039dad1f2975',
  avataxServiceUsage250: '2c92a0ff51e898b50152039d7c9026c7',
  avataxServiceUsage500: '2c92a0fd51e888940152039d94dd2d9d',
  avataxServiceUsage1500: '2c92a0fd51e8883c0152039d53bb4b4d',
  stateLicense: '2c92a0ff65a88c5b0165aaf721d35da8',
};

export const signInURL = `${config.CLIENT_URL}${getAuthLogin()}`;
export const signInLinkAndText = `<a href="${signInURL}">Sign in</a>`;

const loggedInSupportUrl = `${config.SUPPORT_URL}`;
export const submitPublicSupportCaseTextAndLink =
  '<a href="https://avalaracommunity.force.com/ContactAvalara/s/SubmitCase" target=\'_blank\'>Submit a support case</a>';
export const submitSupportCaseTextAndLink = `<a href="${loggedInSupportUrl}">Submit a support case</a>`;

export const breakpoints = {
  tablet: 750,
  phone: 520,
};
